"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignoutIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const SignoutIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M16 17V19.5C16 19.7761 15.7761 20 15.5 20H5.5C5.22386 20 5 19.7761 5 19.5V4.5C5 4.22386 5.22386 4 5.5 4H15.5C15.7761 4 16 4.22386 16 4.5V7", fill: "transparent", stroke: "#2F2D2E", strokeWidth: "2" }),
    react_1.default.createElement("path", { d: "M18 14.7929V9.20711C18 8.76165 18.5386 8.53857 18.8536 8.85355L21.6464 11.6464C21.8417 11.8417 21.8417 12.1583 21.6464 12.3536L18.8536 15.1464C18.5386 15.4614 18 15.2383 18 14.7929Z" }),
    react_1.default.createElement("rect", { x: "8", y: "11", width: "11", height: "2", rx: "0.5" })));
exports.SignoutIcon = SignoutIcon;
exports.default = exports.SignoutIcon;
